import { CrudState } from "@/store/modules/crud/State";

export class State extends CrudState {
  generatedCatalog: any | null = null;
  countCatalogPages: any | null = null;
}
